import styled from 'styled-components';

export const HeaderContainer = styled.header`
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    @media screen and (max-width: 600px){
        padding: 0 10px;
    }
`;

export const GoBackButton = styled.button`
    width: 40px;
    height: 40px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: background-color 0.2s;
    &:hover {
        background-color: #f3f4f6;
    }
    & > svg {
        color: #1f2937;
    }
`;

export const ProfileButton = styled.button`
    width: 40px;
    height: 40px;
    border: none;
    background-color: #028322;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
    &:hover {
        background-color: #026818;
    }
    & > svg {
        color: #fff;
    }
`;

export const Link = styled.a`

    text-decoration: none;
    color: ${({ active }) => active ? '#fff' : '#4b5563'};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 36px;
    padding: 0 16px;
    box-sizing: border-box;
    font-weight: ${({ active }) => active ? '600' : '500'};
    font-size: 0.875rem;
    transition: all 0.2s ease;
    background-color: ${({ active }) => active ? '#028322' : 'transparent'};
    border-radius: ${({ active }) => active ? '8px' : '0px'};
    margin: 0 2px;

    &:hover{
        background-color: ${({ active }) => active ? '#026818' : '#f3f4f6'};
        border-radius: 8px;
        color: ${({ active }) => active ? '#fff' : '#1f2937'};
    }
`;


export const SearchContainer = styled.div`
    width: 400px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-sizing: border-box;
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    top: 0px;
    z-index: 100;
    overflow: auto;
    flex-wrap: wrap;
    transition: all 0.2s ease;
    @media screen and (max-width: 600px){
        display: none;
    }

    ${({ searchFocus }) => searchFocus ? `
        box-shadow: 0 0 0 3px rgba(2, 131, 34, 0.1);
        border-color: #028322;
        ` : `
        &:hover {
            border-color: #d1d5db;
        }
        `}
`;

export const SearchInput = styled.input`
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    padding: 0 12px;
    box-sizing: border-box;
    font-size: 0.875rem;
    font-weight: 400;
    color: #1f2937;
    &::placeholder{
        color: #9ca3af;
    }
`;

export const SearchContent = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 0px;
    box-sizing: border-box;
    overflow-y: scroll;
    &::-webkit-scrollbar{
        width: 5px;
    }
    &::-webkit-scrollbar-thumb{
        background-color: #028322;
    }
    &::-webkit-scrollbar-track{
        background-color: #e0e0e0;
    }
`;